import { useState } from 'react';

const useHighlightedClick = () => {
  const [highlightedByValue, setHighlightedByValue] = useState<{ [value: string]: boolean }>({});
  const changeValuesHighlight = (value: string, isHighlighted: boolean) =>
    setHighlightedByValue({ ...highlightedByValue, [value]: isHighlighted });
  const setHighlighted = (value: string) => {
    changeValuesHighlight(value, true);
    setTimeout(() => changeValuesHighlight(value, false), 250);
  };
  const isHighlighted = (value: string): boolean => !!highlightedByValue[value];

  return { isHighlighted, setHighlighted };
};

export default useHighlightedClick;
